module.exports = __webpack_public_path__ + "img/_Sourbrick.ff97aa8e.png";